import api from './api';

// Get all subcategories
export const getSubcategories = async (categoryId = null) => {
    const url = categoryId ? `/subcategories?categoryId=${categoryId}` : '/subcategories';
    const response = await api.get(url);
    return response.data;
};

// Get subcategory by ID
export const getSubcategory = async (id) => {
    const response = await api.get(`/subcategories/${id}`);
    return response.data;
};

// Create subcategory (Super Admin only)
export const createSubcategory = async (subcategoryData) => {
    const response = await api.post('/subcategories', subcategoryData);
    return response.data;
};

// Update subcategory (Super Admin only)
export const updateSubcategory = async (id, subcategoryData) => {
    const response = await api.put(`/subcategories/${id}`, subcategoryData);
    return response.data;
};

// Delete subcategory (Super Admin only)
export const deleteSubcategory = async (id) => {
    const response = await api.delete(`/subcategories/${id}`);
    return response.data;
};

// Bulk delete subcategories (Super Admin only)
export const bulkDeleteSubcategories = async (subcategoryIds) => {
    const response = await api.delete('/subcategories/bulk', {
        data: { ids: subcategoryIds }
    });
    return response.data;
};